import React from 'react';
import PropTypes from 'prop-types';

import { Image, BackButton } from 'C4';
import { appContentUrl, appContentNewUrl } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const icons = {
  '': 'align-right',
  autoPlay: 'play',
  Photo: 'images',
};

const Sidebar = (props) => {
  const { appId, items, image } = props;
  const list = items.map((item, i) => {
    const {
      name, type, active, onClick,
    } = item;
    const key = `sidebar_item_${i}`;
    return (
      <li onClick={onClick} key={key} className={active ? 'active' : null}>
        {/* <span>{`${`0${i + 1}`.slice(-2)}.`}</span> */}
        <FontAwesomeIcon icon={['fas', icons[type]]} />
        <span>{name}</span>
      </li>
    );
  });

  return (
    <ul className="sidebar">
      <Image
        src={image}
        alt={image}
        className="header__image"
      />
      {list}
    </ul>
  );
};

export default Sidebar;

Sidebar.propTypes = {
  appId: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.oneOf(['', 'autoPlay', 'Photo']),
  })).isRequired,
  image: PropTypes.string.isRequired,
};
